import lessRequire from '../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-modal';

import '../../../shared/modules/shared/modal.less';
lessRequire('modules/shared/modal.less');

const propTypes = {
	className: PropTypes.string,
	overlayClassName: PropTypes.string,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	title: PropTypes.string,
	body: PropTypes.node,
	children: PropTypes.node,
	closeOnOverlayClick: PropTypes.bool
};

const defaultProps = {
	closeOnOverlayClick: true
};

const ModalBox = props => {

	return (
		<Modal
			className={props.className || 'modal-overlay__content'}
			overlayClassName={props.overlayClassName || 'modal-overlay'}
			isOpen={props.isOpen}
			onRequestClose={props.onClose}
			shouldCloseOnOverlayClick={props.closeOnOverlayClick}
			contentLabel="Modal"
		>
			<Container {...props} />
		</Modal>
	);
};

class Container extends React.Component {
	componentDidMount() {
		document.body.style.overflow = 'hidden';
	}

	componentWillUnmount() {
		document.body.style.overflow = 'visible';
	}

	render() {
		const { props } = this;

		return (
			<div className="modal-wrap">
				<h3 className="font-proxima-nova-bold">{props.title}</h3>
				<a
					href="#"
					className="modal-close"
					onClick={e => {
						e.preventDefault();
						props.onClose();
					}}
				/>
				{props.body || props.children}
			</div>
		);
	}
}

ModalBox.propTypes = propTypes;
ModalBox.defaultProps = defaultProps;

export default ModalBox;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/modal.js